// @flow

export const COMPANY_LOGO_SAVE = 'COMPANY_LOGO_SAVE'
export const COMPANY_LOGO_WAS_SAVED = 'COMPANY_LOGO_WAS_SAVED'
export const COMPANY_LOGO_RESET = 'COMPANY_LOGO_RESET'
export const COMPANY_LOGO_ERROR = 'COMPANY_LOGO_ERROR'

export const COMPANY_UPDATE = 'COMPANY_UPDATE'
